import { Button, CloseSvg, colors, Margin } from '@spritz-finance/ui'
import styled from 'styled-components'
import { PopupId, useViewedPopups } from '../../utils/useViewedPopups'

const Banner = styled.div`
    background: ${colors.ltAqua[25]};
    display: flex;
    justify-content: center;
    align-items: center;
    height: 120px;
`
const TextContent = styled.div`
    position: relative;
    padding: 0 ${Margin.Small};
    max-width: 464px;
`

interface InfoBannerProps {
    bannerId?: PopupId
}

export const InfoBanner: React.FC<InfoBannerProps> = ({ bannerId, children }) => {
    const { hasViewed, setViewed } = useViewedPopups()

    if (bannerId && hasViewed(bannerId)) return null

    return (
        <Banner>
            <TextContent>
                {children}
                {bannerId && (
                    <Button.Icon
                        style={{
                            position: 'absolute',
                            top: '-25px',
                            right: '-15px',
                            margin: 0,
                        }}
                        icon={CloseSvg}
                        onClick={() => setViewed(bannerId)}
                    />
                )}
            </TextContent>
        </Banner>
    )
}
